import PropTypes from 'prop-types'
import { klass } from 'utils'

/**
 * Your plain old `<i>`/`<em>`, but with Chinese augmentation, since their chars don't usually look drunk when emphatic.
 * By default, italics (emphasis) in Chinese is replaced by dots below the characters... But this is only used for words, instead of whole sentences. While in English italics might be used to emphasize titles and whole sentences, in Chinese that's done differently. Thus, you should use ONE of the boolean attributes to point out the best approach given the context. Using no attribute has the exact same effect of a plain `<i>`: small dots below the Chinese characters.
 * @param b {boolean} Uses bold instead of italics
 * @param q {boolean} Uses quotation marks instead of italics
 * @param force {boolean} Uses italics even in Chinese
 * @param en {boolean} No emphasis in Chinese
 * @param zh {boolean} Does nothing in English and only emphasizes Chinese
 * @param className {string}
 * @param children
 * @returns {JSX.Element}
 */
export default function I({ b = false, q = false, force = false, en = false, zh = false, className = '', children }) {
	const cls = klass(className, {
		zhBold : b,
		zhForce: force,
		zhNo   : en,
		zhOnly : zh,
		zhQuote: q,
	})
	return <i {...cls}>{children}</i>
}

I.propTypes = {
	b        : PropTypes.bool,
	q        : PropTypes.bool,
	force    : PropTypes.bool,
	en       : PropTypes.bool,
	zh       : PropTypes.bool,
	className: PropTypes.string,
}

//alternative version in case we need these rules for another language. This was an initial version, but ends up being more verbose than the version above. I didn't remove it since it could be flexed to contain different attributes for any language.
// export default function I({ zh = undefined, children }) {
// 	const cls = klass({
// 		zhBold : ['b', 'bold'].includes(zh),
// 		zhForce: ['f', 'force'].includes(zh),
// 		zhNo   : ['n', 'no'].includes(zh),
// 		zhOnly : ['o', 'only'].includes(zh),
// 		zhQuote: ['q', 'quote'].includes(zh),
// 	})
// 	return <i className={cls}>{children}</i>
// }
//
// I.propTypes = {
// 	zh: PropTypes.oneOf(['bold', 'b', 'force', 'f', 'no', 'n', 'only', 'o', 'quote', 'q'])
// }
